import { CustomSelect } from "../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardHeader
} from "../../../../../_metronic/_partials/controls";

export const TermAndSectionCard = ({
  title,
  term,
  sections,
  setTerm,
  setSectionId
}) => (
  <Card>
    <CardHeader title={title} />
    <CardBody>
      <div className="form-group row">
        <div className="col-4 mt-3">
          Dönem <span>*</span>
        </div>
        <div className="col-4">
          <input
            type="number"
            className="form-control"
            min={1}
            value={term}
            placeholder="Dönem"
            onChange={e => setTerm(parseInt(e.target.value))}
          />
        </div>
        <div className="col-4">
          <input className="form-control" value={term ? term + 1 : ""} readOnly />
        </div>
      </div>

      <div className="form-group row">
        <div className="col-4 mt-3">
          Şube <span>*</span>
        </div>
        <div className="col-8">
          <CustomSelect
            options={sections}
            onChange={option => setSectionId(option.value)}
          />
        </div>
      </div>
    </CardBody>
  </Card>
);